import React, { useEffect } from 'react';

const Helmet = (props) => {
  const { title, component: Component, ...rest } = props;

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return (
    <React.Fragment>
      <Component {...rest} />
    </React.Fragment>
  );
};

export default Helmet;
